function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "shapes",
  fill: "#e7eef1"
}, /*#__PURE__*/React.createElement("path", {
  d: "m19.981 31.715 2.743-4.8 8.119 4.709-8.119 4.791-2.743-4.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.951 42.75 8.23-4.663L30.3 52.213 13.951 42.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.311 22.745 5.157 8.933-5.157 8.759V22.745z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.942 20.386 16.366-9.417-8.137 14.229-8.229-4.812z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.399 22.115 7.141 4.123-2.359 4.169-4.782-8.292z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m33.281 31.568 17.452-10.057v20.151L33.281 31.568z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.268 37.484 8.713-5.186 18.121 10.461-17.856 10.313-8.978-15.588z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "circle",
  fill: "#e7eef1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.064 1.3a.64.64 0 0 1-.457-.183.649.649 0 0 1-.192-.468.613.613 0 0 1 .192-.457.64.64 0 0 1 .905-.009l.009.009a.613.613 0 0 1 .192.457.649.649 0 0 1-.192.466.64.64 0 0 1-.457.183",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.537 1.4a.64.64 0 0 1-.437-.216.649.649 0 0 1-.158-.484.613.613 0 0 1 .228-.436.64.64 0 0 1 .9.064l.008.01a.613.613 0 0 1 .155.471.649.649 0 0 1-.229.449.64.64 0 0 1-.47.146",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.993 1.707a.64.64 0 0 1-.422-.254.649.649 0 0 1-.115-.491.613.613 0 0 1 .263-.42.64.64 0 0 1 .895.136l.007.01a.613.613 0 0 1 .116.482.649.649 0 0 1-.264.429.64.64 0 0 1-.48.107",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.417 2.207a.64.64 0 0 1-.4-.287.649.649 0 0 1-.075-.5.613.613 0 0 1 .3-.4.64.64 0 0 1 .881.208l.007.011a.613.613 0 0 1 .077.49.649.649 0 0 1-.3.406.64.64 0 0 1-.488.068",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.792 2.9a.64.64 0 0 1-.375-.318.649.649 0 0 1-.034-.5.613.613 0 0 1 .327-.373.64.64 0 0 1 .861.278l.005.013a.613.613 0 0 1 .037.494.649.649 0 0 1-.33.381.64.64 0 0 1-.491.029",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.1 3.785a.64.64 0 0 1-.349-.348.649.649 0 0 1 .006-.5.613.613 0 0 1 .356-.345.64.64 0 0 1 .836.347v.012a.613.613 0 0 1 0 .5.649.649 0 0 1-.349.349.64.64 0 0 1-.5-.015",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.337 4.851a.64.64 0 0 1-.319-.375.649.649 0 0 1 .047-.5.613.613 0 0 1 .383-.315.64.64 0 0 1 .805.413v.012a.613.613 0 0 1-.043.494.649.649 0 0 1-.387.323.64.64 0 0 1-.49-.051",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.477 6.094a.64.64 0 0 1-.288-.4.649.649 0 0 1 .087-.5.613.613 0 0 1 .407-.283.64.64 0 0 1 .769.477V5.4a.613.613 0 0 1-.082.489.649.649 0 0 1-.412.291.64.64 0 0 1-.484-.09",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.51 7.506a.64.64 0 0 1-.255-.421.649.649 0 0 1 .127-.485.613.613 0 0 1 .428-.25.64.64 0 0 1 .729.537V6.9a.613.613 0 0 1-.121.481.649.649 0 0 1-.434.257.64.64 0 0 1-.475-.129",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.423 9.076a.64.64 0 0 1-.22-.44.649.649 0 0 1 .166-.476.613.613 0 0 1 .447-.214.64.64 0 0 1 .683.594v.012a.613.613 0 0 1-.16.469.649.649 0 0 1-.453.221.64.64 0 0 1-.463-.166",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.2 10.8a.64.64 0 0 1-.184-.457.649.649 0 0 1 .2-.461.613.613 0 0 1 .469-.182.64.64 0 0 1 .633.647v.013a.613.613 0 0 1-.2.455.649.649 0 0 1-.469.184.64.64 0 0 1-.448-.2",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.839 12.653a.64.64 0 0 1-.147-.47.649.649 0 0 1 .24-.443.613.613 0 0 1 .476-.14.64.64 0 0 1 .579.7v.013a.613.613 0 0 1-.233.438.649.649 0 0 1-.483.146.64.64 0 0 1-.431-.239",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.32 14.636a.64.64 0 0 1-.109-.48.649.649 0 0 1 .275-.422.613.613 0 0 1 .485-.1.64.64 0 0 1 .521.74v.013a.613.613 0 0 1-.267.417.649.649 0 0 1-.493.106.64.64 0 0 1-.41-.273",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.636 16.732a.64.64 0 0 1-.07-.487.649.649 0 0 1 .308-.4.613.613 0 0 1 .492-.062.64.64 0 0 1 .459.78v.012a.613.613 0 0 1-.3.394.649.649 0 0 1-.5.066.64.64 0 0 1-.387-.3",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.779 18.927a.64.64 0 0 1-.03-.491.649.649 0 0 1 .339-.373.613.613 0 0 1 .5-.022.64.64 0 0 1 .4.814v.012a.613.613 0 0 1-.331.369.649.649 0 0 1-.5.026.64.64 0 0 1-.361-.335",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.742 21.207a.64.64 0 0 1 .01-.492.649.649 0 0 1 .368-.344.613.613 0 0 1 .5.018.64.64 0 0 1 .328.843l-.005.012a.613.613 0 0 1-.36.341.649.649 0 0 1-.5-.015.64.64 0 0 1-.333-.363",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.518 23.557a.64.64 0 0 1 .049-.49.649.649 0 0 1 .395-.314.613.613 0 0 1 .492.058.64.64 0 0 1 .259.867l-.006.011a.613.613 0 0 1-.386.311.649.649 0 0 1-.5-.055.64.64 0 0 1-.3-.388",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.1 25.962a.64.64 0 0 1 .089-.484.649.649 0 0 1 .419-.281.613.613 0 0 1 .486.1.64.64 0 0 1 .189.885l-.007.011a.613.613 0 0 1-.41.279.649.649 0 0 1-.495-.1.64.64 0 0 1-.27-.412",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.49 28.406a.64.64 0 0 1 .127-.476.649.649 0 0 1 .44-.246.613.613 0 0 1 .477.136.64.64 0 0 1 .117.9l-.008.01a.613.613 0 0 1-.431.245.649.649 0 0 1-.486-.135.64.64 0 0 1-.236-.432",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.68 30.874a.64.64 0 0 1 .165-.464.649.649 0 0 1 .455-.21.613.613 0 0 1 .464.174.64.64 0 0 1 .044.9l-.009.009a.613.613 0 0 1-.449.21.649.649 0 0 1-.473-.174.64.64 0 0 1-.2-.45",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.671 33.349a.64.64 0 0 1 .2-.449.649.649 0 0 1 .474-.172.613.613 0 0 1 .449.211.64.64 0 0 1-.029.9l-.009.009a.613.613 0 0 1-.465.173.649.649 0 0 1-.458-.211.64.64 0 0 1-.164-.464",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.463 35.815a.64.64 0 0 1 .237-.431.649.649 0 0 1 .486-.134.613.613 0 0 1 .43.246.64.64 0 0 1-.1.9l-.016.004a.613.613 0 0 1-.477.135.649.649 0 0 1-.439-.248.64.64 0 0 1-.126-.476",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.057 38.256a.64.64 0 0 1 .271-.411.649.649 0 0 1 .5-.094.613.613 0 0 1 .409.28.64.64 0 0 1-.174.888l-.011.007a.613.613 0 0 1-.486.1.649.649 0 0 1-.418-.282.64.64 0 0 1-.087-.485",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.455 40.657a.64.64 0 0 1 .3-.387.649.649 0 0 1 .5-.054.613.613 0 0 1 .385.312.64.64 0 0 1-.245.871l-.011.006a.613.613 0 0 1-.492.056.649.649 0 0 1-.394-.315.64.64 0 0 1-.048-.49",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.662 43a.64.64 0 0 1 .338-.361.649.649 0 0 1 .5-.013.613.613 0 0 1 .359.342.64.64 0 0 1-.314.849l-.012.005a.613.613 0 0 1-.5.017.649.649 0 0 1-.367-.345.64.64 0 0 1-.004-.494",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.683 45.274a.64.64 0 0 1 .362-.334.649.649 0 0 1 .5.027.613.613 0 0 1 .33.37.64.64 0 0 1-.381.821h-.012a.613.613 0 0 1-.5-.023.649.649 0 0 1-.338-.374.64.64 0 0 1 .032-.491",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.524 47.461a.64.64 0 0 1 .388-.3.649.649 0 0 1 .5.068.613.613 0 0 1 .3.4.64.64 0 0 1-.446.787h-.012a.613.613 0 0 1-.492-.063.649.649 0 0 1-.307-.4.64.64 0 0 1 .071-.487",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.192 49.547a.64.64 0 0 1 .411-.271.649.649 0 0 1 .492.108.613.613 0 0 1 .266.418.64.64 0 0 1-.508.749h-.013a.613.613 0 0 1-.485-.1.649.649 0 0 1-.274-.423.64.64 0 0 1 .11-.48",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.7 51.519a.64.64 0 0 1 .431-.237.649.649 0 0 1 .482.147.613.613 0 0 1 .232.438.64.64 0 0 1-.567.705h-.016a.613.613 0 0 1-.475-.141.649.649 0 0 1-.239-.444.64.64 0 0 1 .148-.469",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.047 53.364a.64.64 0 0 1 .449-.2.649.649 0 0 1 .469.185.613.613 0 0 1 .2.456.64.64 0 0 1-.622.657h-.017a.613.613 0 0 1-.462-.179.649.649 0 0 1-.2-.462.64.64 0 0 1 .186-.456",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.255 55.071a.64.64 0 0 1 .464-.165.649.649 0 0 1 .452.223.613.613 0 0 1 .158.47.64.64 0 0 1-.673.605h-.012a.613.613 0 0 1-.446-.216.649.649 0 0 1-.164-.477.64.64 0 0 1 .222-.439",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.331 56.627a.64.64 0 0 1 .476-.127.649.649 0 0 1 .433.258.613.613 0 0 1 .12.481.64.64 0 0 1-.719.549h-.013a.613.613 0 0 1-.427-.251.649.649 0 0 1-.125-.488.64.64 0 0 1 .256-.42",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.287 58.024a.64.64 0 0 1 .484-.088.649.649 0 0 1 .411.292.613.613 0 0 1 .081.489.64.64 0 0 1-.761.489h-.012a.613.613 0 0 1-.406-.285.649.649 0 0 1-.086-.5.64.64 0 0 1 .289-.4",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.138 59.251a.64.64 0 0 1 .49-.049.649.649 0 0 1 .386.324.613.613 0 0 1 .041.494.64.64 0 0 1-.8.426h-.012a.613.613 0 0 1-.382-.316.649.649 0 0 1-.045-.5.64.64 0 0 1 .321-.374",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.9 60.3a.64.64 0 0 1 .492-.009.649.649 0 0 1 .358.354.613.613 0 0 1 0 .5.64.64 0 0 1-.83.361h-.012a.613.613 0 0 1-.355-.346.649.649 0 0 1 0-.5.64.64 0 0 1 .347-.36",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.579 61.167a.64.64 0 0 1 .491.03.649.649 0 0 1 .329.382.613.613 0 0 1-.039.494.64.64 0 0 1-.856.293l-.011-.006a.613.613 0 0 1-.326-.374.649.649 0 0 1 .036-.5.64.64 0 0 1 .376-.317",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.2 61.844a.64.64 0 0 1 .487.07.649.649 0 0 1 .3.407.613.613 0 0 1-.078.489.64.64 0 0 1-.877.223l-.011-.007a.613.613 0 0 1-.295-.4.649.649 0 0 1 .076-.5.64.64 0 0 1 .4-.286",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.771 62.327a.64.64 0 0 1 .48.109.649.649 0 0 1 .263.43.613.613 0 0 1-.118.482.64.64 0 0 1-.892.151l-.01-.007a.613.613 0 0 1-.262-.421.649.649 0 0 1 .116-.49.64.64 0 0 1 .422-.253",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.313 62.613a.64.64 0 0 1 .47.147.649.649 0 0 1 .227.45.613.613 0 0 1-.156.47.64.64 0 0 1-.9.079l-.01-.008a.613.613 0 0 1-.227-.441.649.649 0 0 1 .155-.479.64.64 0 0 1 .441-.218",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.84 62.7a.64.64 0 0 1 .456.184.649.649 0 0 1 .191.467.613.613 0 0 1-.193.456.64.64 0 0 1-.905.006l-.01-.013a.613.613 0 0 1-.191-.458.649.649 0 0 1 .193-.465.64.64 0 0 1 .459-.177",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.367 62.587a.64.64 0 0 1 .44.221.649.649 0 0 1 .152.48.613.613 0 0 1-.23.439.64.64 0 0 1-.9-.067l-.008-.01a.613.613 0 0 1-.153-.471.649.649 0 0 1 .23-.448.64.64 0 0 1 .471-.144",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.912 62.276a.64.64 0 0 1 .421.255.649.649 0 0 1 .113.491.613.613 0 0 1-.264.419.64.64 0 0 1-.894-.139l-.007-.01a.613.613 0 0 1-.115-.482.649.649 0 0 1 .266-.428.64.64 0 0 1 .481-.106",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.49 61.767a.64.64 0 0 1 .4.288.649.649 0 0 1 .073.5.613.613 0 0 1-.3.4.64.64 0 0 1-.88-.211l-.007-.011a.613.613 0 0 1-.075-.49.649.649 0 0 1 .3-.405.64.64 0 0 1 .488-.067",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.116 61.066a.64.64 0 0 1 .374.32.649.649 0 0 1 .033.5.613.613 0 0 1-.328.372.64.64 0 0 1-.86-.281l-.006-.011a.613.613 0 0 1-.036-.494.649.649 0 0 1 .331-.38.64.64 0 0 1 .492-.027",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.807 60.175a.64.64 0 0 1 .347.349.649.649 0 0 1-.008.5.613.613 0 0 1-.357.344.64.64 0 0 1-.835-.349v-.012a.613.613 0 0 1 0-.5.649.649 0 0 1 .361-.352.64.64 0 0 1 .492.013",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.577 59.1a.64.64 0 0 1 .318.376.649.649 0 0 1-.048.5.613.613 0 0 1-.384.314.64.64 0 0 1-.8-.416v-.012a.613.613 0 0 1 .044-.494.649.649 0 0 1 .388-.322.64.64 0 0 1 .49.052",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.441 57.852a.64.64 0 0 1 .287.4.649.649 0 0 1-.089.5.613.613 0 0 1-.408.282.64.64 0 0 1-.768-.479v-.012a.613.613 0 0 1 .084-.489.649.649 0 0 1 .412-.29.64.64 0 0 1 .484.091",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.413 56.434a.64.64 0 0 1 .254.422.649.649 0 0 1-.128.487.613.613 0 0 1-.429.248.64.64 0 0 1-.727-.539v-.013a.613.613 0 0 1 .123-.48.649.649 0 0 1 .434-.256.64.64 0 0 1 .475.13",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5 54.858a.64.64 0 0 1 .219.441.649.649 0 0 1-.167.475.613.613 0 0 1-.448.213.64.64 0 0 1-.681-.6v-.009a.613.613 0 0 1 .161-.469.649.649 0 0 1 .454-.22.64.64 0 0 1 .463.168",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.73 53.132a.64.64 0 0 1 .183.457.649.649 0 0 1-.2.46.613.613 0 0 1-.463.176.64.64 0 0 1-.631-.649v-.011a.613.613 0 0 1 .2-.454.649.649 0 0 1 .47-.182.64.64 0 0 1 .448.2",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.1 51.27a.64.64 0 0 1 .145.47.649.649 0 0 1-.245.443.613.613 0 0 1-.476.138.64.64 0 0 1-.577-.7v-.01a.613.613 0 0 1 .234-.437.649.649 0 0 1 .483-.144.64.64 0 0 1 .43.24",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.626 49.282a.64.64 0 0 1 .107.481.649.649 0 0 1-.276.422.613.613 0 0 1-.486.1.64.64 0 0 1-.518-.742v-.013a.613.613 0 0 1 .269-.417.649.649 0 0 1 .493-.1.64.64 0 0 1 .409.274",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.316 47.182a.64.64 0 0 1 .068.488.649.649 0 0 1-.309.4.613.613 0 0 1-.492.06.64.64 0 0 1-.457-.781v-.012a.613.613 0 0 1 .3-.394.649.649 0 0 1 .5-.065.64.64 0 0 1 .386.306",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.18 44.984a.64.64 0 0 1 .028.491.649.649 0 0 1-.34.372.613.613 0 0 1-.5.02.64.64 0 0 1-.393-.815v-.012a.613.613 0 0 1 .332-.368.649.649 0 0 1 .5-.024.64.64 0 0 1 .36.336",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.224 42.7a.64.64 0 0 1-.011.492.649.649 0 0 1-.369.343.613.613 0 0 1-.5-.02.64.64 0 0 1-.326-.844l.005-.012a.613.613 0 0 1 .361-.34.649.649 0 0 1 .5.016.64.64 0 0 1 .332.364",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.456 40.348a.64.64 0 0 1-.051.49.649.649 0 0 1-.4.312.613.613 0 0 1-.492-.059.64.64 0 0 1-.257-.868l.006-.011a.613.613 0 0 1 .387-.31.649.649 0 0 1 .5.057.64.64 0 0 1 .3.389",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.879 37.941a.64.64 0 0 1-.09.484.649.649 0 0 1-.419.279.613.613 0 0 1-.486-.1.64.64 0 0 1-.184-.884l.007-.011a.613.613 0 0 1 .411-.278.649.649 0 0 1 .495.1.64.64 0 0 1 .269.412",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.5 35.5a.64.64 0 0 1-.129.475.649.649 0 0 1-.441.245.613.613 0 0 1-.476-.138.64.64 0 0 1-.114-.9l.008-.01a.613.613 0 0 1 .432-.244.649.649 0 0 1 .485.137.64.64 0 0 1 .235.435",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.316 33.028a.64.64 0 0 1-.167.463.649.649 0 0 1-.459.208.613.613 0 0 1-.464-.176.64.64 0 0 1-.041-.9l.009-.009a.613.613 0 0 1 .45-.214.649.649 0 0 1 .473.175.64.64 0 0 1 .2.45",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.333 30.553a.64.64 0 0 1-.2.448.649.649 0 0 1-.474.171.613.613 0 0 1-.451-.212.64.64 0 0 1 .032-.9l.009-.009a.613.613 0 0 1 .465-.171.649.649 0 0 1 .457.213.64.64 0 0 1 .162.465",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.549 28.088a.64.64 0 0 1-.239.43.649.649 0 0 1-.486.132.613.613 0 0 1-.429-.25.64.64 0 0 1 .1-.9l.01-.008a.613.613 0 0 1 .477-.133.649.649 0 0 1 .438.249.64.64 0 0 1 .124.476",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.963 25.648a.64.64 0 0 1-.273.41.649.649 0 0 1-.5.092.613.613 0 0 1-.408-.282.64.64 0 0 1 .177-.888l.011-.007a.613.613 0 0 1 .487-.094.649.649 0 0 1 .417.283.64.64 0 0 1 .086.485",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.572 23.249a.64.64 0 0 1-.3.387.649.649 0 0 1-.5.052.613.613 0 0 1-.384-.313.64.64 0 0 1 .242-.875h.011a.613.613 0 0 1 .493-.055.649.649 0 0 1 .393.316.64.64 0 0 1 .046.49",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.373 20.907a.64.64 0 0 1-.335.361.649.649 0 0 1-.5.012.613.613 0 0 1-.357-.343.64.64 0 0 1 .317-.848l.002-.006a.613.613 0 0 1 .5-.015.649.649 0 0 1 .366.347.64.64 0 0 1 .007.492",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.359 18.637A.64.64 0 0 1 4 18.97a.649.649 0 0 1-.5-.029.613.613 0 0 1-.329-.371.64.64 0 0 1 .384-.82h.012a.613.613 0 0 1 .5.025.649.649 0 0 1 .337.375.64.64 0 0 1-.033.491",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.525 16.454a.64.64 0 0 1-.389.3.649.649 0 0 1-.5-.069.613.613 0 0 1-.3-.4.64.64 0 0 1 .452-.785H4.8a.613.613 0 0 1 .491.065.649.649 0 0 1 .305.4.64.64 0 0 1-.073.487",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.863 14.372a.64.64 0 0 1-.412.27.649.649 0 0 1-.492-.109.613.613 0 0 1-.265-.419.64.64 0 0 1 .511-.747h.013a.613.613 0 0 1 .485.1.649.649 0 0 1 .272.424.64.64 0 0 1-.112.479",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.365 12.4a.64.64 0 0 1-.432.236.649.649 0 0 1-.482-.149.613.613 0 0 1-.23-.439.64.64 0 0 1 .569-.7h.01a.613.613 0 0 1 .475.143.649.649 0 0 1 .237.445.64.64 0 0 1-.15.469",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.02 10.565a.64.64 0 0 1-.45.2.649.649 0 0 1-.47-.187.613.613 0 0 1-.194-.456.64.64 0 0 1 .624-.656h.015a.613.613 0 0 1 .462.181.649.649 0 0 1 .2.462.64.64 0 0 1-.187.455",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.818 8.864a.64.64 0 0 1-.464.163.649.649 0 0 1-.454-.227.613.613 0 0 1-.157-.47.64.64 0 0 1 .675-.6h.013a.613.613 0 0 1 .446.217.649.649 0 0 1 .163.477.64.64 0 0 1-.223.439",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.747 7.314a.64.64 0 0 1-.476.126.649.649 0 0 1-.432-.26.613.613 0 0 1-.119-.48.64.64 0 0 1 .721-.547h.013a.613.613 0 0 1 .427.252.649.649 0 0 1 .119.489.64.64 0 0 1-.258.419",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.794 5.923a.64.64 0 0 1-.485.087.649.649 0 0 1-.41-.294.613.613 0 0 1-.079-.489.64.64 0 0 1 .763-.487h.012a.613.613 0 0 1 .4.286.649.649 0 0 1 .084.5.64.64 0 0 1-.291.4",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.947 4.7a.64.64 0 0 1-.49.047.649.649 0 0 1-.385-.326.613.613 0 0 1-.04-.494.64.64 0 0 1 .8-.424h.012a.613.613 0 0 1 .381.318.649.649 0 0 1 .044.5.64.64 0 0 1-.322.373",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.192 3.66a.64.64 0 0 1-.492.008.649.649 0 0 1-.357-.356.613.613 0 0 1 0-.5.64.64 0 0 1 .831-.358h.012a.613.613 0 0 1 .354.347.649.649 0 0 1 0 .5.64.64 0 0 1-.351.345",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.513 2.8a.64.64 0 0 1-.491-.032.649.649 0 0 1-.327-.383.613.613 0 0 1 .04-.494.64.64 0 0 1 .857-.29l.008.006a.613.613 0 0 1 .325.375.649.649 0 0 1-.038.5.64.64 0 0 1-.377.316",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.9 2.131a.64.64 0 0 1-.487-.071.649.649 0 0 1-.3-.408.613.613 0 0 1 .08-.489.64.64 0 0 1 .878-.22l.011.007a.613.613 0 0 1 .293.4.649.649 0 0 1-.078.5.64.64 0 0 1-.4.285",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.324 1.656a.64.64 0 0 1-.48-.11.649.649 0 0 1-.262-.431.613.613 0 0 1 .118-.481.64.64 0 0 1 .895-.149l.005.008a.613.613 0 0 1 .26.422.649.649 0 0 1-.118.49.64.64 0 0 1-.423.251",
  transform: "translate(-.019)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.783 1.378a.64.64 0 0 1-.469-.149.649.649 0 0 1-.226-.45.613.613 0 0 1 .158-.47.64.64 0 0 1 .9-.076l.01.008a.613.613 0 0 1 .225.441.649.649 0 0 1-.157.479.64.64 0 0 1-.442.216",
  transform: "translate(-.019)"
}));

function SvgBrandLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo);
export default __webpack_public_path__ + "static/media/brand-logo.4e0ac66549217f10d602cf18a0f0d186.svg";
export { ForwardRef as ReactComponent };